export enum ValidationStates {
  Valid,
  InvalidShowError,
}
